export enum ImageKey {
  PreviewImage = 'preview-image',
}
